// NOTE: Please check with #eng-all before adding anything here! Do not add any private keys or information!
export const whitelistedEnvVars = {
  adminSegmentWriteKey: process.env.ADMIN_SEGMENT_WRITE_KEY,
  adminUrl: process.env.ADMIN_URL,
  aerosyncConfigurationId: process.env.AEROSYNC_CONFIGURATION_ID,
  amplitudeApiKey: process.env.AMPLITUDE_API_KEY,
  apiUrl: process.env.API_URL,
  appEnv: process.env.APP_ENV,
  basisTheoryKey: process.env.BASIS_THEORY_KEY,
  // Base URL of the Web Studio (CMS) Cloudflare Worker. Safe to expose: it's a public
  // origin, and its Puck AI endpoint (/api/puck/*) is called directly from the browser by
  // the CMS editors' AI plugin (see apps/marketplace/src/cms/editor/use-puck-ai-plugin.ts).
  cmsApiUrl: process.env.CMS_API_URL,
  // Cloudflare-for-SaaS CNAME target hostname (see config/initializers/cloudflare.rb in
  // Armageddon). Safe to expose: it's a public DNS target customers CNAME their domain to, same
  // reasoning as cmsApiUrl above -- used client-side to build the Web Studio preview-domain
  // fallback before a customer has connected a real domain (see use-website-domain.ts).
  cloudflareSaasCnameTarget: process.env.CLOUDFLARE_SAAS_CNAME_TARGET,
  consumerConciergeMfRemoteUrl: process.env.CONSUMER_CONCIERGE_MF_REMOTE_URL,
  consumerUrl: process.env.CONSUMER_URL,
  currentVersion: process.env.CURRENT_VERSION,
  enableDevAccountPicker: process.env.ENABLE_DEV_ACCOUNT_PICKER,
  googleAnalyticsID: 'UA-101536475-1',
  gtmContainerKey: process.env.GTM_CONTAINER_KEY,
  isE2E: process.env.E2E,
  launchDarklyClientId: process.env.LAUNCH_DARKLY_CLIENT_ID,
  launchDarklyBaseUri: process.env.CLIENT_LD_BASE_URI,
  launchDarklyStreamUri: process.env.CLIENT_LD_STREAM_URI,
  launchDarklyEventsUri: process.env.CLIENT_LD_EVENTS_URI,
  paysafeEnvironment: process.env.PAYSAFE_ENVIRONMENT,
  pendoApiKey: process.env.PENDO_API_KEY,
  plaidEnv: process.env.PLAID_ENV,
  plaidKey: process.env.PLAID_KEY,
  pusherKey: process.env.PUSHER_KEY,
  sessionContextCookieName: process.env.SESSION_CONTEXT_COOKIE_NAME,
  siftBeaconKey: process.env.SIFT_BEACON_KEY,
  streamKey: process.env.STREAM_MESSAGING_KEY_ID,
  stripeKey: process.env.STRIPE_PKEY,
  turnstileSiteKey: process.env.CF_TURNSTILE_SITE_KEY,
  vectorPersonalizeApiUrl: process.env.VECTOR_PERSONALIZE_API_URL,
};
